/* Copyright Information: Created by BuyGroup */
import React from "react";
import { Container } from "reactstrap";
import { Redirect } from "react-router-dom";
import HomeContainer from "./HomeContainer";
import HeaderTwo from "../../components/headers/header-two";
import FooterTwo from "../../components/footers/footer-two";
import HeaderResponsive from "../headers/HeaderResponsive";
// import Header from "./Header";
import { isLoggedIn } from "../../utils";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleMenu: false,
    };
  }
  toggleButton = () => {
    this.setState((prevState) => ({ toggleMenu: !prevState.toggleMenu }));
  };

  render() {
    const { location } = this.props;
    const params = new URLSearchParams(location.search || "");
    const hasAccessCode = !!params.get("accessCode");
    const isRootPath = location.pathname === "/";
    const showHeaderTwo = !(isRootPath && !hasAccessCode);

    if (isRootPath && isLoggedIn() && !hasAccessCode) {
      return <Redirect to="/public" />;
    }

    return (
      <>
        <React.Fragment>
          {/* {showHeaderTwo && <HeaderTwo />} */}
          {showHeaderTwo && <HeaderResponsive />}
          <div className={`clearfix mb-5 ${showHeaderTwo ? "mt-5" : ""}`}>
            <Container>
              <HomeContainer
                handleMainClass={this.state.toggleMenu}
                {...this.props}
              />
            </Container>
          </div>
          <FooterTwo />
        </React.Fragment>
      </>
    );
  }
}

export default Home;
/* Copyright Information: Created by BuyGroup */
